import Model from '~/models/base/Model';

export class ArtifactItem extends Model {
    constructor(id, value) {
        super(id);
        this.id = id;
        this.value = value;
        this.incidentId = null;
        this.artifactId = null;
    }

    create() {
        const requestUrl = `${Model._url}/incidents/${this.incidentId}/artifacts/${this.artifactId}/${this.id}/`;
        const requestPayload = { value: this.value };
        return this.constructor.api.post(requestUrl, requestPayload);
    }

    update(data) {
        const requestUrl = `${Model._url}/incidents/${this.incidentId}/artifacts/${this.artifactId}/${this.id}/`;
        const requestPayload = data; // <<
        return this.constructor.api.patch(requestUrl, requestPayload);
    }

    remove() {
        const requestUrl = `${Model._url}/incidents/${this.incidentId}/artifacts/${this.artifactId}/${this.id}/`;
        return this.constructor.api.delete(requestUrl);
    }
}

/**
 * class representing artifact
 * @extends Model
 * @author fm
 */
export default class Artifact extends Model {
    constructor(id, incidentId) {
        super(id);
        this._url = `${Model._url}/incidents/${incidentId}/artifacts/${
            id ? `${id}/` : ''
        }`;
    }

    static all(incidentId) {
        const requestUrl = `${Model._url}/incidents/${incidentId}/artifacts/`;
        return this.api.get(requestUrl).then(response => {
            const respData = response.data;
            return 200 !== response.status ? respData : respData.data;
        });
    }

    static get(incidentId, artifactId) {
        const requestUrl = `${Model._url}/incidents/${incidentId}/artifacts/${artifactId}/`;
        return this.api.get(requestUrl).then(response => {
            const respData = response.data;
            if (200 !== response.status) {
                return respData;
            }
            const data = respData.data;
            const cefFields = data.cef_fields;
            const items = Object.keys(cefFields).map(key => {
                const value = cefFields[key];
                const artifactItem = new ArtifactItem(key, value);
                artifactItem.incidentId = incidentId;
                artifactItem.artifactId = artifactId;
                return artifactItem;
            });
            const container = new Artifact(artifactId, incidentId);
            container.type = data.type;
            container.count = data.id;
            container.items = items;
            return container;
        });
    }

    static getCefFields() {
        const requestUrl = `${Model._url}/incidents/getceffieldsjson/`;
        return this.api.get(requestUrl);
    }

    createItem(key, value) {
        const item = new ArtifactItem(key, value);
        item.artifactId = this.id;
        item.incidentId = this.incidentId;
        return item;
    }

    save() {
        const requestUrl = this._url;
        const requestPayload = {
            tag: this.tag,
            cef: this.items.reduce((acc, item) => {
                acc[item.id] = item.value;
                return acc;
            }, {})
        };
        return this.constructor.api.post(requestUrl, requestPayload);
    }

    delete() {
        const requestUrl = this._url;
        return this.constructor.api.delete(requestUrl);
    }

    updateTags(params) {
        const requestUrl = this._url;
        const requestPayload = params ?? {};
        return this.constructor.api.put(requestUrl, requestPayload);
    }
}
